var EventMode;
(function (EventMode) {
    EventMode["URL"] = "url";
    EventMode["PostMessage"] = "postmessage";
    EventMode["Android"] = "android";
    // tslint:disable-next-line:naming-convention
    EventMode["iOS"] = "ios";
})(EventMode || (EventMode = {}));
function getEventMode() {
    if (window.CheckoutSDKAndroid) {
        return EventMode.Android;
    }
    if (window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.CheckoutSDKiOS) {
        return EventMode.iOS;
    }
    if (window.self !== window.top) {
        return EventMode.PostMessage;
    }
    return EventMode.URL;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

var AbstractDispatcher = /** @class */ (function () {
    function AbstractDispatcher(
    // tslint:disable-next-line:no-unused
    eventMode, 
    // tslint:disable-next-line:no-unused
    options) {
        this.eventMode = eventMode;
        this.options = options;
    }
    AbstractDispatcher.prototype.updateOptions = function (options) {
        this.options = __assign({}, this.options, options);
    };
    return AbstractDispatcher;
}());

var AndroidDispatcher = /** @class */ (function (_super) {
    __extends(AndroidDispatcher, _super);
    function AndroidDispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AndroidDispatcher.prototype.dispatch = function (eventType, payload) {
        window.CheckoutSDKAndroid.dispatchEvent(eventType, JSON.stringify(payload));
    };
    return AndroidDispatcher;
}(AbstractDispatcher));

var IosDispatcher = /** @class */ (function (_super) {
    __extends(IosDispatcher, _super);
    function IosDispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IosDispatcher.prototype.dispatch = function (eventType, payload) {
        window.webkit.messageHandlers.CheckoutSDKiOS.postMessage({
            eventType: eventType,
            payload: JSON.stringify(payload)
        });
    };
    return IosDispatcher;
}(AbstractDispatcher));

var CheckoutEvent;
(function (CheckoutEvent) {
    /** A payment has been authorized. */
    CheckoutEvent["Authorize"] = "authorize";
    /**
     * The Checkout session has been canceled.
     * Checkout requests for its modal to be closed.
     *
     * To avoid a redirect, reply immediately with the
     * `AcknowledgeCloseRequest` action.
     */
    CheckoutEvent["Cancel"] = "cancel";
    /**
     * The Checkout session has been completed.
     * Checkout requests for its modal to be closed.
     *
     * To avoid a redirect, reply immediately with the
     * `AcknowledgeCloseRequest` action.
     */
    CheckoutEvent["Close"] = "close";
    /** A payment type has been selected. */
    CheckoutEvent["PaymentTypeSelection"] = "paymentTypeSelection";
    /** The payment card type has been determined. */
    CheckoutEvent["CardTypeResolve"] = "cardTypeResolve";
    /** Checkout session is loaded and is ready to serve. */
    CheckoutEvent["Ready"] = "ready";
})(CheckoutEvent || (CheckoutEvent = {}));
var CheckoutEvent$1 = CheckoutEvent;

var UrlDispatcher = /** @class */ (function (_super) {
    __extends(UrlDispatcher, _super);
    function UrlDispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UrlDispatcher.prototype.dispatch = function (eventType, 
    // tslint:disable-next-line:no-unused
    payload) {
        if (eventType === CheckoutEvent$1.Close) {
            window.location.href = decodeURIComponent(this.options
                .acceptUrl);
        }
        if (eventType === CheckoutEvent$1.Cancel) {
            if (this.options.cancelUrl) {
                window.location.href = decodeURIComponent(this.options
                    .cancelUrl);
            }
            else {
                window.history.back();
            }
        }
        return;
    };
    return UrlDispatcher;
}(AbstractDispatcher));

var PostMessageDispatcher = /** @class */ (function (_super) {
    __extends(PostMessageDispatcher, _super);
    function PostMessageDispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PostMessageDispatcher.prototype.dispatch = function (eventType, payload) {
        if (!this.options.handshakeId)
            return;
        if (typeof this.options.handshakeId === "string") {
            window.parent.postMessage({ payload: payload, handshakeId: this.options.handshakeId, event: eventType }, "*");
            return;
        }
        this.options.handshakeId.then(function (handshakeId) {
            window.parent.postMessage({ payload: payload, handshakeId: handshakeId, event: eventType }, "*");
        });
    };
    return PostMessageDispatcher;
}(AbstractDispatcher));

var checkoutDispatcherMap = (_a = {}, _a[EventMode.Android] = AndroidDispatcher, _a[EventMode.URL] = UrlDispatcher, _a[EventMode.PostMessage] = PostMessageDispatcher, _a[EventMode.iOS] = IosDispatcher, _a);
function createCheckoutDispatcher(options) {
    var eventMode = getEventMode();
    var checkoutDispatcherConstructable = checkoutDispatcherMap[eventMode];
    return new checkoutDispatcherConstructable(eventMode, options);
}
var _a;

export { createCheckoutDispatcher, AbstractDispatcher, CheckoutEvent$1 as CheckoutEvent };
